module.exports = __webpack_public_path__ + "static/media/02.807940dc.jpg";